import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

const Seg = ({ s, side }) => {
  if (s.op === "eq") return <span>{s.text}</span>;
  if (s.op === "del") return side === "a" ? <span className="line-through decoration-2 text-red-600 bg-red-50">{s.text}</span> : null;
  return side === "b" ? <b className="text-orange-600 bg-orange-50">{s.text}</b> : null;
};

// Issued vs proposed: struck-through red removals on the left, bold orange additions on the right.
export function WsCompare({ a, b, onClose }) {
  const [data, setData] = useState(null);
  const [clean, setClean] = useState(false);
  useEffect(() => { api.get(`/policies/revisions/compare?a=${a}&b=${b}`).then((r) => setData(r.data)).catch(() => setData({ error: true })); }, [a, b]);
  const td = data?.text_diff;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="ws-compare" className="max-w-6xl">
        <DialogHeader>
          <DialogTitle>{data ? `Rev ${data.a.revision} (issued) → Rev ${data.b.revision} (proposed)` : "Comparing…"}</DialogTitle>
          <DialogDescription>{td ? `${td.changed} changed · ${td.added} added · ${td.removed} removed paragraphs` : ""}</DialogDescription>
        </DialogHeader>
        {data?.error && <p className="text-sm text-red-600">Could not load the comparison.</p>}
        {data?.is_pdf && <p data-testid="ws-compare-pdf" className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-3">One or both versions are PDFs, so there is no editable text to compare. Open each revision from the history to review it.</p>}
        {td && !data.is_pdf && (<>
          <div className="inline-flex rounded-lg border border-slate-200 overflow-hidden text-sm self-start">
            <button data-testid="ws-compare-side" onClick={() => setClean(false)} className={`px-3 py-1.5 font-semibold ${!clean ? "bg-slate-900 text-white" : "bg-white text-slate-600"}`}>Show changes</button>
            <button data-testid="ws-compare-clean" onClick={() => setClean(true)} className={`px-3 py-1.5 font-semibold ${clean ? "bg-slate-900 text-white" : "bg-white text-slate-600"}`}>Clean reading</button>
          </div>
          {!td.has_changes && <p data-testid="ws-compare-nochange" className="text-sm text-slate-500">No text differences.</p>}
          <div className="max-h-[62vh] overflow-y-auto">
            {clean ? (
              <div data-testid="ws-compare-clean-view" className="flex flex-col gap-2 text-sm text-slate-800 max-w-3xl">
                {td.rows.filter((r) => r.status !== "removed").map((r, i) => <p key={i}>{r.segments.filter((s) => s.op !== "del").map((s) => s.text).join("")}</p>)}
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-x-4 text-sm" data-testid="ws-compare-grid">
                <div className="text-[10px] font-bold uppercase text-slate-400 pb-1 border-b">Issued</div>
                <div className="text-[10px] font-bold uppercase text-slate-400 pb-1 border-b">Proposed</div>
                {td.rows.map((r, i) => (
                  <div key={i} className="contents">
                    <div className={`py-1.5 border-b border-slate-100 ${r.status === "same" ? "text-slate-500" : ""}`}>{r.status !== "added" && r.segments.map((s, j) => <Seg key={j} s={s} side="a" />)}</div>
                    <div className={`py-1.5 border-b border-slate-100 ${r.status === "same" ? "text-slate-500" : ""}`}>{r.status !== "removed" && r.segments.map((s, j) => <Seg key={j} s={s} side="b" />)}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </>)}
      </DialogContent>
    </Dialog>
  );
}
